import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'

//根据代码集id获取代码集
export function getDicts(obj) {
  return request({
    url: urlPrefix + '/code/getcodeitem',
    method: 'get',
    data: obj,
  });
}
//020201-05 根据当前用户 查询所有前端初始化代码项排除后的代码项 用来下拉先
export function getServerDictsList() {
  return request({
    url: urlPrefix + '/code/getcodeitemlist',
    method: 'get',
  });
}
//020201-05 根据当前用户查询所有前端初始化代码项排除后的代码项 用来翻译
export function getServerDictsMap() {
  return request({
    url: urlPrefix + '/code/getcodeitemmap',
    method: 'get',
  });
}

//020201-05 查询租户下的代码项集合
export function getDictsListBySetId(codeSetId) {
  return request({
    url: urlPrefix + '/code/api/tenantId/'+codeSetId+'/codeItem',
    method: 'get',
  });
}

// 分页查询代码集
export function getCodeSetListPage(obj) {
  return request({
    url: urlPrefix + '/code/queryCodeSetList',
    method: 'post',
    data: obj
  });
}
// 新增代码集
export function addCodeItemSet(obj){
  return request({
    url: urlPrefix + '/code/saveSysCodeSet',
    method: 'post',
    data: obj
  });
}
// 修改代码集
export function updateCodeSet(obj){
  return request({
    url: urlPrefix + '/code/editCodeSet',
    method: 'post',
    data: obj
  })
}

//批量修改代码集状态
export function changeCodeSetStatus(obj){
  return request({
    url: urlPrefix + '/code/changeCodeSetStatus',
    method: 'post',
    data: obj
  })
}

//分页查询代码项
export function getCodeItemListPage(obj){
  return request({
    url: urlPrefix + '/code/queryCodeItemList',
    method: 'post',
    data: obj
  })
}
// 新增代码项
export function saveCodeItem(obj){
  return request({
    url: urlPrefix + '/code/savecode',
    method: 'post',
    data: obj
  })
}
// 修改代码项
export function updatecode(obj){
  return request({
    url: urlPrefix + '/code/editcode',
    method: 'post',
    data: obj
  })
}

// 批量修改代码项
export function changeCodeItemStatus(obj){
  return request({
    url: urlPrefix + '/code/changeCodeItemStatus',
    method: 'post',
    data: obj
  })
}
//清理缓存
export function recacheCodeItem(obj) {
  return request({
    url:urlPrefix+ '/code/recacheCodeItem',
    method: 'post',
    data: obj
  })
}
//清理缓存
export function recacheCodeSet(obj) {
  return request({
    url:urlPrefix+ '/code/recacheCodeSet',
    method: 'post',
    data: obj
  })
}

//宁波乾象获取基值
export function sysCodeItemQxValueList(obj) {
  return request({
    url:urlPrefix+ '/metashares/sysCodeItemQxValueList',
    method: 'post',
    data: obj
  })
}

//宁波乾象修改基值
export function sysCodeItemQxValueUpdate(obj) {
  return request({
    url:urlPrefix+ '/metashares/sysCodeItemQxValueUpdate',
    method: 'post',
    data: obj
  })
}
//宁波乾象新增基值
export function sysCodeItemQxValueAdd(obj) {
  return request({
    url:urlPrefix+ '/metashares/sysCodeItemQxValueAdd',
    method: 'post',
    data: obj
  })
}

//宁波乾象删除基值
export function sysCodeItemQxValueDelete(obj) {
  return request({
    url:urlPrefix+ '/metashares/sysCodeItemQxValueDelete',
    method: 'post',
    data: obj
  })
}
